/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {ServiceError} from '@ion/core/src/types/services';
import {
  SERVICE_ERROR,
  SERVICE_ERROR_DISMISS,
  SERVICE_ERROR_RETRY
} from '../actions/errors';
import {LOGIN_SUCCEEDED} from '../actions/login';

// defines the shape of this reducers state ...
export interface ErrorsState {
  error: ServiceError | null;
  notify: false;
  isCritical: boolean;
  isWarning: boolean;
}

// defines the initial state for the reducer ...
const initialState: ErrorsState = {
  error      : null,
  notify     : false,
  isCritical : false,
  isWarning  : false
};

const reset = draft => {
  draft.error      = null;
  draft.notify     = false;
  draft.isCritical = false;
  draft.isWarning  = false;
};

// defines the reducers ...
const reducers = {
  [SERVICE_ERROR] : (draft, {error}) => {
    const {isCritical, isWarning} = error;
    draft.error      = error;
    draft.notify     = isCritical || isWarning;
    draft.isCritical = isCritical;
    draft.isWarning  = isWarning;
  },
  [LOGIN_SUCCEEDED] : draft => {
    reset(draft);
  },
  [SERVICE_ERROR_DISMISS] : draft => {
    reset(draft);
  },
  [SERVICE_ERROR_RETRY] : draft => {
    reset(draft);
  }
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: ErrorsState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
